"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { MOBILE_BREAKPOINT } from "../constants/breakpoints";
type WindowSize = {
  width: number;
  height: number;
  isDesktop: boolean;
  isMobile: boolean;
};
export const useWindowSize = () => {
  const $ = _c(2);
  const [windowSize, setWindowSize] = useState(_temp);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (typeof window === "undefined") {
        return;
      }
      const handleResize = () => {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
          isDesktop: window.innerWidth > MOBILE_BREAKPOINT,
          isMobile: window.innerWidth <= MOBILE_BREAKPOINT
        });
      };
      window.addEventListener("resize", handleResize);
      handleResize();
      return () => window.removeEventListener("resize", handleResize);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return windowSize;
};
function _temp() {
  if (typeof window !== "undefined") {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
      isDesktop: window.innerWidth > MOBILE_BREAKPOINT,
      isMobile: window.innerWidth <= MOBILE_BREAKPOINT
    };
  }
  return {
    width: 0,
    height: 0,
    isDesktop: true,
    isMobile: false
  };
}